/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Spellcheck_Start_ErrorInputs */



/**
* | output |
* | --- |
* | "There was an error starting spell check {error}" |
*
* @param {Spellcheck_Start_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_start_error = /** @type {((inputs: Spellcheck_Start_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Start_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors du demarrage de la verification orthographique ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Beim Starten der Rechtschreibprüfung ist ein Fehler aufgetreten ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'avvio del controllo ortografico ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Произошла ошибка при запуске проверки орфографии ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se produjo un error al iniciar la corrección ortográfica ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`开始拼写检查时出错 ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スペルチェック ${i?.error} の開始中にエラーが発生しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वर्तनी जाँच शुरू करने में त्रुटि आई ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ocorreu um erro ao iniciar a verificação ortográfica ${i?.error}`)
	return /** @type {LocalizedString} */ (`There was an error starting spell check ${i?.error}`)
});